
export function findMiddleElement(arr) {
    if (!arr?.length) {
        return 0; // Return undefined for empty array
    }

    const midIndex = Math.floor(arr.length / 2);

    // If the array has an odd number of elements, return the middle one
    if (arr.length % 2 !== 0) {
        return arr[midIndex];
    } else {
        // For even-length arrays, return the element at length/2 (consider the definition)
        // Alternatively, you could return (arr[midIndex - 1] + arr[midIndex]) / 2 for the average of the two middle numbers
        return arr[midIndex];
    }
}
